import { Center, Container, Flex, Loader } from "@mantine/core";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { COLORS } from "../../../constants/colorConstants";
import { useCalendarContext } from "../../../contexts/CalendarContext";
import { useLocalAuthorityContext } from "../../../contexts/LocalAuthorityContext";
import ErrorCard from "../../../shared/components/blocks/ErrorCard";
import CalendarViewDatesCard from "./components/CalendarViewDatesCard";
import CalendarViewDetailsCard from "./components/CalendarViewDetailsCard";
import CalendarViewHeader from "./components/CalendarViewHeader";

export default function CalendarView() {
  const { id } = useParams();
  const { singleFetch, calendarDatesFetch } = useCalendarContext();
  const { dropdownFetch } = useLocalAuthorityContext();

  useEffect(() => {
    singleFetch.setCalendarId(id);
  }, [id]);

  useEffect(() => {
    dropdownFetch.enableDropdownFetch();
  }, []);

  const Content = () => {
    if (singleFetch?.isPending || calendarDatesFetch?.isPending) {
      return (
        <Center>
          <Loader color={COLORS.DARK_WINE} size="xl" type="bars" />
        </Center>
      );
    }

    if (singleFetch?.error) {
      return <ErrorCard error={singleFetch.error} />;
    }

    if (calendarDatesFetch?.error) {
      return <ErrorCard error={calendarDatesFetch.error} />;
    }

    return (
      <Flex gap="xl">
        <CalendarViewDetailsCard />
        <CalendarViewDatesCard />
      </Flex>
    );
  };

  return (
    <Container fluid>
      <CalendarViewHeader />
      <Content />
    </Container>
  );
}
